module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_5010.c6343acb.png";